export const dogFaq = [
    {
        question: "What is in-home dog sitting and how is it different from kennels?",
        answer: "In-home dog sitting means a verified sitter cares for your dog in your own home. Your dog keeps familiar routines, space and smells, which reduces stress compared with boarding kennels."
    },
    {
        question: "Are your dog sitters verified and reviewed?",
        answer: "Yes. Sitters complete ID checks and build profiles with references and homeowner reviews. You can read feedback, message sitters and arrange a video call before confirming."
    },
    {
        question: "How much does dog sitting cost with HouseSit Match?",
        answer: "Registration is free. A membership is required to contact sitters or post a request. The sit itself is usually an exchange of care for accommodation, so owners do not pay sitters a fee unless agreed for specialist or extended arrangements."
    },
    {
        question: "Can sitters give medication or follow special routines?",
        answer: "Many sitters have experience with puppies, seniors and medication schedules. Share your dog’s routine and any care needs in your request and shortlist sitters with the right experience."
    },
    {
        question: "How far in advance should I book a dog sitter?",
        answer: "Peak periods such as school holidays and summer fill quickly. Post your request as soon as you know your dates so you can review more profiles and secure the best match."
    },
    {
        question: "I am a sitter. How do I find dog sitting opportunities?",
        answer: "Create a sitter profile, verify your ID and browse available sits. Use filters for location, dates and pet type, then apply to listings that match your skills and availability."
    },
    {
        question: "What happens if plans change after we confirm?",
        answer: "Communicate early through the platform. Most members can adjust dates or find alternatives, and our support team can help guide next steps if you need assistance."
    },
];

export const catFaq = [
    {
        question: "What does an in-home cat sitter do day to day?",
        answer: "They follow your care plan with feeding times, fresh water, litter cleaning and simple home tasks like plants or post. Most owners choose daily photo updates.",
    },
    {
        question: "Can I book daily visits instead of overnight care?",
        answer: "Yes. You can request once or twice daily visits or full overnight stays. Choose what suits your cat and confirm the schedule before booking.",
    },
    {
        question: "How do you handle multi-cat households with different needs?",
        answer: "Add notes for each cat including diets, meds and quirks. Sitters follow individual instructions and keep updates clear for each cat.",
    },
    {
        question: "Do sitters give medication like insulin or pills?",
        answer: "Many sitters are experienced with tablets, liquids and insulin. Share your vet guidance and demonstrate your routine during the meet and greet.",
    },
    {
        question: "What if my cat is shy or hides from new people?",
        answer: "Sitters use slow introductions and quiet routines and let the cat choose contact. Updates focus on appetite, litter use and signs of calm like grooming or play.",
    },
    {
        question: "How is litter box hygiene handled?",
        answer: "Sitters scoop daily, refresh litter as instructed and wipe the area. They note changes like diarrhea or straining so you can follow up if needed.",
    },
    {
        question: "What happens in an emergency vet situation?",
        answer: "Leave vet details and a spending limit. Sitters contact you first when possible, then follow your emergency plan and keep receipts and notes.",
    },
    {
        question: "Do owners pay sitters on HouseSit Match?",
        answer: "Most sits are an exchange of care for accommodation with no nightly fee. Any payment for specialist or extended arrangements should be agreed in advance.",
    },
];

export const birdFaq = [
    {
        question: "Can bird sitters care for birds with special dietary needs?",
        answer: "Yes, bird sitters can follow specific feeding plans, including preparing custom diets for birds with unique nutritional requirements. Ensure detailed instructions are provided during the briefing.",
    },
    {
        question: "How do bird sitters handle birds that need daily out-of-cage time?",
        answer: "Sitters are briefed on your bird's routine, including supervised free-roaming schedules, ensuring your bird gets the physical activity and stimulation it needs safely.",
    },
    {
        question: "What if my bird requires medication or special care?",
        answer: "Experienced sitters can administer medication or follow precise care routines as directed. It's essential to communicate these needs clearly before the sit begins.",
    },
    {
        question: "Are sitters comfortable with larger or exotic birds?",
        answer: "Many sitters have experience with a variety of bird species, including larger parrots and exotic birds. You can specify your requirements when posting an assignment to find the right match.",
    },
    {
        question: "Can bird sitters handle multiple birds or an aviary?",
        answer: "Absolutely. Sitters can care for individual birds, multiple pets, or even large aviaries, provided they are given a clear briefing on cleaning, feeding, and maintenance routines.",
    },
];

export const rabbitFaq = [
    {
        question: "What if my rabbit has special needs?",
        answer: "Our sitters accommodate specific requirements, including medical care, dietary restrictions, and unique routines. Discuss these details with your sitter during the matching process.",
    },
    {
        question: "Can I become a rabbit sitter without prior experience?",
        answer: "Absolutely! Enthusiasm, attention to detail, and a willingness to learn are key. HouseSit Match offers resources to help you succeed.",
    },
    {
        question: "Can a rabbit sitter handle bonding between two rabbits?",
        answer: "If bonding is in progress, a sitter can follow your guidelines to supervise and manage introductions. Make sure to explain the process clearly and provide any necessary tools or instructions.",
    },
    {
        question: "How often should a rabbit sitter check on my rabbit?",
        answer: "Rabbit sitters typically follow the care schedule you outline, which may include daily visits or staying in your home to ensure consistent care and attention.",
    },
    {
        question: "What should I do if my rabbit is shy or nervous around new people?",
        answer: "Provide sitters with tips to help build trust, such as offering treats or approaching slowly. Sitters on HouseSit Match are trained to handle rabbits gently and patiently.",
    },
];

export const petSittingFaq = [
    {
        question: "What does an in-home pet sitter do compared with kennels or catteries?",
        answer: "An in-home sitter cares for your pets in your house. Routines stay the same, your pets keep their own space, and you get updates while you travel. Many owners prefer this to boarding because it reduces stress and keeps home security covered.",
    },
    {
        question: "How much does pet sitting cost with HouseSit Match?",
        answer: "Registration is free. A paid membership is needed to contact sitters or post a request. Most sits are an exchange of care for accommodation, so owners usually do not pay a sitter fee unless you agree to something for specialist or extended needs. See plans for pet owners at housesitmatch.com/membership-plans/homeowner.",
    },
    {
        question: "Should I choose a live-in pet sitter or daily visits?",
        answer: "Live-in care keeps routines most consistent and suits anxious, senior, or multi-pet households. Daily visits can work for independent pets or short trips. Pick the option that matches your pets' temperament and care needs.",
    },
    {
        question: "Can sitters give medication or follow special routines?",
        answer: "Yes. Many sitters have experience with medication schedules, special diets, habitat cleaning, and shy or senior pets. Include clear notes in your request and shortlist sitters who list the right experience.",
    },
    {
        question: "How do I find local or last-minute pet sitters?",
        answer: "Use filters to search by location and dates, then message available sitters directly. If you need cover soon, post your request as early as possible and contact several suitable profiles to speed up matching. Start your house sitter search at housesitmatch.com/search-house-sitter.",
    },
    {
        question: "How does HouseSit Match keep things safe?",
        answer: "Sitters complete ID checks and build profiles with references and homeowner reviews. Messaging stays on the platform, and you can arrange a video call before confirming. Agree house rules and emergency contacts in writing. Learn more at housesitmatch.com/trust-and-safety.",
    },
    {
        question: "I am a sitter. How do I get chosen for my first sit?",
        answer: "Create a friendly, detailed profile, verify your ID, and apply to listings that match your experience. Be clear about dates, include pet-relevant skills, and request reviews after each sit to build your reputation. Browse current house sits at housesitmatch.com/search-house-sit.",
    },
]


export const searchHouseSitFaq = [
    {
        question: "Do house sitters get paid?",
        answer: "Most house sitting opportunities are based on an exchange: free accommodation in return for caring for the home and pets. While some long-term or specialist sits may offer payment, the main benefit is staying rent-free in trusted homes worldwide.",
    },
    {
        question: "Can I find international house sitting jobs?",
        answer: "Yes. HouseSit Match connects sitters with verified homeowners around the world. You can find listings in the UK, Europe, Australia, North America and beyond.",
    },
    {
        question: "How do I apply for house sitting jobs?",
        answer: "Once you’ve created your sitter profile, you can browse available listings and apply directly. Messaging happens securely through our platform so you can agree details with homeowners before confirming your sit.",
    },
    {
        question: "What experience do I need to start house sitting?",
        answer: "You don’t need professional experience to join. Many successful sitters simply have a love of pets, a sense of responsibility and a friendly approach. References and reviews help you build trust as you complete more sits.",
    },
    {
        question: "Do I need to be in the UK to find sits?",
        answer: "Not at all. While many listings are UK-based, our platform is international. You can find house sitting jobs locally or abroad depending on your travel plans and membership level.",
    },
]

export const searchHouseSitterFaq = [
    {
        question: "Can I find local house sitters near me?",
        answer: "Yes. HouseSit Match lets you filter sitters by location so you can find someone nearby. Many of our members are based across the UK and Europe, with international sitters also available for longer stays.",
    },
    {
        question: "How do I verify a sitter’s credentials?",
        answer: "All sitters complete ID verification and many also provide police checks and references. You can review their profile, read feedback from other homeowners and message them directly through our secure platform.",
    },
    {
        question: "What happens if I need a sitter at short notice?",
        answer: "We have an active community of responsive sitters who often accept last-minute listings. Post your house sit as soon as possible to reach available members quickly.",
    },
    {
        question: "Do sitters look after pets too?",
        answer: "Yes. Most of our sitters are also experienced pet sitters, offering full care for dogs, cats and other animals while you’re away. You can filter profiles by pet experience when searching.",
    },
    {
        question: "How do I list my house sitting opportunity?",
        answer: "Simply create a homeowner profile, choose a membership plan and post your listing. Sitters can then apply directly, allowing you to review profiles and confirm the best match.",
    },
]